namespace GeniuzPOS.AdvPromo {
    export interface AdvPromoDetailRequest extends Serenity.ListRequest {
        PmId?: string;
        PmType?: string;
        PmGroupId?: string;
        SupplCode?: string;
        SkuCode?: string;
        PluCode?: string;
        StyleId?: string;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        BrandCode?: string;
    }
}
